<template>
  <transition name="modal-animation">
    <div v-show="modalActive" class="modal">
      <transition name="modal-animation-inner">
        <div v-show="modalActive" class="modal-inner" :class="size ? size : ''">
          <div class="header-modal">
          <h3 class="text-uppercase">{{titulo}}</h3>
          <i @click="close" class="far fa-times-circle" v-if="btnClose"></i>

          </div>
          <!-- Modal Content -->
          <slot />
        </div>
      </transition>
    </div>
  </transition>
</template>

<script setup>
defineProps({
    modalActive: {type: Boolean, default: false},
    titulo: '',
    size: null,
    btnClose: {type: Boolean, default: true}
})

const emits = defineEmits(['close'])

const close = () => {
    emits("close");
};
</script>

<style lang="scss" scoped>
.modal-animation-enter-active,
.modal-animation-leave-active {
  transition: opacity 0.3s cubic-bezier(0.52, 0.02, 0.19, 1.02);
}
.modal-animation-enter-from,
.modal-animation-leave-to {
  opacity: 0;
}
.modal-animation-inner-enter-active {
  transition: all 0.3s cubic-bezier(0.52, 0.02, 0.19, 1.02) 0.15s;
}
.modal-animation-inner-leave-active {
  transition: all 0.3s cubic-bezier(0.52, 0.02, 0.19, 1.02);
}
.modal-animation-inner-enter-from {
  opacity: 0;
  transform: scale(0.8);
}
.modal-animation-inner-leave-to {
  transform: scale(0.8);
}
.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.7);
  &.height-search .modal-inner{
    padding: 50px 16px 0 16px;
  }
  .md{
    max-width: 768px!important;
  }
  .lg{
    max-width: 991px!important;
  }
  .xl{
    max-width: 1140px!important;
  }
  .modal-inner {
    position: relative;
    border-radius: 12px;
    max-width: 650px;
    width: 95%;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
    background-color: #fff;
    padding: 70px 16px;
    h3{
      position: absolute;
      top: 15px;
      left: 15px;
      font-size: 20px;
    }
    i {
      position: absolute;
      top: 15px;
      right: 15px;
      font-size: 2rem;
      cursor: pointer;
      transition: 0.3s all;
      &:hover {
        color: crimson;
      }
    }
  }
  @media(max-width: 370px){
    .modal-inner{
      h3{
        font-size: 1rem;
      }
    }
  }
}
</style>